import { EstateTrusts } from '@/modules/estate/EstateTrusts/EstateTrusts';

export function ClientEstateTrustsPage() {
  return <EstateTrusts />;
}
